import React, { useState, useContext, FC } from "react";
import { useNavigation } from "@react-navigation/native";
import { View, Text, StyleSheet } from "react-native";
import BalanceAccountModal from "../../components/modals/BalanceAccountModal";
import StyledButton from "../../components/StyledButton";
import StyledIcon from "../../components/StyledIcon";
import Colors from "../../constants/Colors";
import FontStyles from "../../constants/FontStyle";
import { AuthContext } from "../../contexts/auth/Store";
import useFetch from "../../hooks/useFetch";
import { IBuyer } from "../../interfaces/buyer";
import { ILedger, LedgerHead, LedgerSubhead } from "../../interfaces/ledger";
import { ledgerService } from "../../services/LedgerService";
import { formatCurrency } from "../../utils/money";

export const BalanceNotificationCard: FC<{ isInvoicePage?: boolean }> = ({
  isInvoicePage,
}) => {
  const navigation = useNavigation();
  const auth = useContext(AuthContext);
  const buyer: IBuyer = auth.state.buyerData;

  const [showDetail, setShowDetail] = useState(false);

  const hideDetail = (): void => {
    setShowDetail(false);
  };

  const [ledger] = useFetch<ILedger>(
    ledgerService,
    "fetchByOwnerSpecific",
    [
      {
        head: LedgerHead.Buyer,
        subhead: LedgerSubhead.Wallet,
        owner: buyer?._id,
      },
    ],
    !!buyer?._id
  );

  return (
    <>
      {ledger && ledger?.balance < 0 && (
        <View style={styles.main}>
          <View style={styles.container}>
            <StyledIcon
              iconName="exclamation"
              iconColor={Colors.whiteColor}
              iconLibrary="MaterialCommunityIcons"
              fillColor={Colors.dangerText}
            />
            <View style={styles.content}>
              <Text style={styles.heading}>
                Notice of outstanding payment.
              </Text>
              <Text style={styles.body}>
                We have not received any payment. You still have had an
                outstanding balance of{` `}
                <Text style={styles.emphasis}>
                  {formatCurrency(Math.abs(ledger?.balance || 0))}
                </Text>
                {` `}on your account.
              </Text>
              <View style={styles.actionContainer}>
                <View>
                  <StyledButton
                    label="Pay with Transfer"
                    action={() => setShowDetail(true)}
                    color="dangerInverted"
                  />
                </View>
                {!isInvoicePage && (
                  <View>
                    <StyledButton
                      label="View invoices"
                      color="transparent"
                      action={() => navigation.navigate("Order")}
                    />
                  </View>
                )}
              </View>
            </View>
          </View>

          <BalanceAccountModal
            modalState={showDetail}
            hideModal={hideDetail}
            ledger={ledger}
          />
        </View>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  main: {
    padding: 16,
    backgroundColor: Colors.whiteColor,
  },
  container: {
    borderRadius: 6,
    borderWidth: 1,
    borderColor: Colors.dangerText,
    borderStyle: "solid",
    backgroundColor: Colors.dangerBackground,
    flexDirection: "row",
    padding: 12,
  },
  content: {
    flex: 1,
    flexGrow: 1,
    flexDirection: "column",
    paddingLeft: 8,
  },
  heading: {
    ...FontStyles.semibold,
    ...FontStyles.size14,
    ...FontStyles.lh18,
    ...FontStyles.dark,
  },
  body: {
    ...FontStyles.normal,
    ...FontStyles.size14,
    ...FontStyles.lh22,
    ...FontStyles.dark,
  },
  emphasis: {
    ...FontStyles.bold,
    color: Colors.dangerText,
    marginHorizontal: 4,
    flex: 1
  },
  actionContainer: {
    flexDirection: "row",
    marginTop: 10,
    justifyContent: "space-between",
  },
});
